import { useCallback, useEffect, useState } from 'react';

import SearchExperiments from 'bundles/epic/clients/__generated__/search';

const SEARCH_EXPLAIN_SESSION_KEY = 'enableSearchExplain';

/**
 * Hook to manage the search explain state with session storage persistence
 * Only available to Courserians and superusers
 */
export const useSearchExplainState = () => {
  // Check user permissions first
  const hasPermission = SearchExperiments.get('enableSearchExplainer');

  const [enableSearchExplain, setEnableSearchExplain] = useState<boolean>(false);

  const toggleSearchExplain = useCallback<() => void>(() => {
    if (!hasPermission) {
      return;
    }

    setEnableSearchExplain((prev) => {
      const newValue = !prev;
      if (typeof window !== 'undefined') {
        sessionStorage.setItem(SEARCH_EXPLAIN_SESSION_KEY, String(newValue));
      }
      return newValue;
    });
  }, [hasPermission]);

  // Load from session storage on mount (client-side only)
  useEffect(() => {
    if (!hasPermission) {
      setEnableSearchExplain(false);
      return;
    }

    if (typeof window === 'undefined') {
      return;
    }

    const stored = sessionStorage.getItem(SEARCH_EXPLAIN_SESSION_KEY);
    if (stored !== null) {
      setEnableSearchExplain(stored === 'true');
    }
  }, [hasPermission]);

  return {
    hasPermission,
    enableSearchExplain,
    toggleSearchExplain,
  };
};

export default useSearchExplainState;
